import React from "react";
import PropTypes from "prop-types";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";

import { ReactSelect } from "../component";

export const CourseArea = ({
  course,
  title,
  label,
  placeholderMessage,
  associableCourses,
  onChange,
  isLoadingCourse,
  isLoadingAssociableCourses,
  onFocusElement,
  ...rest
}) => {
  const showAssociatedCourse = course?.id && (!associableCourses || associableCourses.length <= 0);
  const showCourseSelector = associableCourses && associableCourses.length > 0;
  const showCourseArea = showAssociatedCourse || showCourseSelector;
  const selectedCourse = course?.id ? [{ label: course.title, value: course.id }] : null;

  if (isLoadingCourse) {
    return null;
  }

  return (
    <>
      {showCourseArea && (
        <div {...{ "data-label": "project-course-area" }}>
          {showAssociatedCourse && (
            <Text size="small" display="block" {...rest}>
              {title}
            </Text>
          )}

          {showCourseSelector && (
            <ReactSelect
              size="small"
              label={label}
              name="course"
              id="course"
              onChange={selected => onChange({ courseId: selected.value })}
              defaultValue={selectedCourse}
              options={[{ label: "--", value: "null" }, ...associableCourses]}
              loading={isLoadingAssociableCourses}
              placeholderMessage={placeholderMessage}
              onFocusElement={onFocusElement}
              {...rest}
            />
          )}
        </div>
      )}
    </>
  );
};

CourseArea.propTypes = {
  course: PropTypes.object,
  title: PropTypes.string,
  label: PropTypes.string,
  placeholderMessage: PropTypes.string,
  associableCourses: PropTypes.array,
  onChange: PropTypes.func,
  onFocusElement: PropTypes.func,
  isLoadingCourse: PropTypes.bool,
  isLoadingAssociableCourses: PropTypes.bool,
};

CourseArea.defaultProps = {
  course: {},
  title: "",
  label: "",
  placeholderMessage: "",
  associableCourses: [],
  onChange: () => {},
  onFocusElement: () => {},
  isLoadingCourse: false,
  isLoadingAssociableCourses: false,
};

export default CourseArea;
